module.exports = __webpack_public_path__ + "img/youtube.15a7372.svg";